module.exports = __webpack_public_path__ + "img/06.0e33139d.svg";